import script from "./QuizWrong.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizWrong.vue?vue&type=script&setup=true&lang=js"

import "./QuizWrong.vue?vue&type=style&index=0&id=29e39520&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e39520"]])

export default __exports__